import { postApi } from "./getApiBase";
import { jwtSign } from "./jwt";

type validateArgs = {
  id: number;
};

export const makeInvites = async (args: validateArgs) => {
  const encrypted = jwtSign(args);

  const makeInvites = await postApi("make-invites", encrypted);

  return await makeInvites.json();
};
